import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedValue, QueryString } from '@grandvisionhq/utils';
import { useBloomreach, useBrPageContext } from '../context/context.js';
import { getUrl } from '../utils/get-url.js';

function useBloomreachProductRoutes() {
    var ref, ref1;
    const { locale  } = useIntl();
    const { pageModel , excludeSkuFromProductUrls  } = useBloomreach();
    const page = useBrPageContext();
    var ref2;
    const productRoutes = (ref2 = pageModel === null || pageModel === void 0 ? void 0 : (ref = pageModel.page) === null || ref === void 0 ? void 0 : (ref1 = ref.models) === null || ref1 === void 0 ? void 0 : ref1.productRoutes) !== null && ref2 !== void 0 ? ref2 : {};
    const hasRoutes = productRoutes && Object.keys(productRoutes).length > 0;
    if (!hasRoutes) {
        var ref3;
        console.log(`Could not get productRoutes for page with name ${pageModel === null || pageModel === void 0 ? void 0 : (ref3 = pageModel.page) === null || ref3 === void 0 ? void 0 : ref3.name}, got: ${String(productRoutes)}`);
    }
    const sortedProductRoutes = hasRoutes ? Object.entries(productRoutes).reduce((acc, [productType, route], i)=>{
        // TODO: remove when BR pageModel is updated
        // Skip legacy implementation key
        if (productType === '$ref') {
            return acc;
        }
        acc.byProductType[productType] = route;
        acc.checksum = `${acc.checksum}|${i}-${productType}:${route}`;
        return acc;
    }, {
        byProductType: {},
        checksum: ''
    }) : null;
    const formatProductUrl = React.useCallback((product, additionalQueryParams = {})=>{
        if (!CommerceToolsApi.isProductTypeName(product.productType) || !sortedProductRoutes) {
            return '#';
        }
        const targetPath = sortedProductRoutes.byProductType[product.productType];
        if (!targetPath) {
            console.warn(`No targetPath (root of url) found to format product url for productType ${product.productType}, got targetPath: ${String(targetPath)}`);
            return '';
        }
        const [path, query] = targetPath.split('?');
        const slug = typeof product.slug === 'string' ? product.slug : getLocalizedValue(product.slug, locale);
        const sku = !!product.sku && !excludeSkuFromProductUrls ? `/${product.sku}` : '';
        // Merge original query from url with any additionalQueryParams that were passed
        const allQueryParams = swcHelpers.objectSpread({}, Boolean(query) ? QueryString.parse(query) : {}, additionalQueryParams);
        const queryString = Object.keys(allQueryParams).length > 0 ? QueryString.stringify(allQueryParams) : '';
        const productUrl = `${path}/${slug}${sku}${queryString}`;
        return getUrl(productUrl, page) || '';
    }, [
        sortedProductRoutes,
        locale,
        excludeSkuFromProductUrls,
        page
    ]);
    // Omit a $ref from the productRoutes object
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const routes = swcHelpers.objectWithoutProperties(productRoutes, [
        "$ref"
    ]);
    return React.useMemo(()=>[
            {
                hasRoutes
            },
            {
                formatProductUrl
            },
            routes
        ]
    , [
        hasRoutes,
        formatProductUrl,
        routes
    ]);
}

export { useBloomreachProductRoutes };
//# sourceMappingURL=use-bloomreach-product-routes.js.map
